/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import {LocalDate} from 'spine-web/proto/spine/time/time_pb';
import LocalDateExt from '@/shell/model/spine/time/LocalDateExt';

/**
 * If a license's expiration date is this much days or less from today, the respective record
 * has to be highlighted respectively.
 */
const expirationProximityHighlightingDays = 7;

/**
 * @param activeThrough  the expiration date whose proximity should be calculated
 * @return the number of days excluding today until the expiration date
 *         (including the expiration date). In particular, 0 means that the license expires today
 *         but is still active, and negative numbers mean that a license has already expired.
 */
export function getDaysUntilExpiration(activeThrough: LocalDate): number {
  const activeThroughExt = LocalDateExt.of(activeThrough);
  const today = LocalDateExt.today();
  const daysRemaining = today.until(activeThroughExt);
  return daysRemaining;
}

/**
 * @param activeThrough the expiration date to check
 * @return true if the given date is considered to be in the close future and requires
 *         highlighting the respective license as a "near expiration date" one.
 */
export function isNearExpirationDate(activeThrough: LocalDate): boolean {
  const daysRemaining = getDaysUntilExpiration(activeThrough);
  const nearExpirationDate = daysRemaining >= 0 && daysRemaining <= expirationProximityHighlightingDays;
  return nearExpirationDate;
}
